import gql from 'graphql-tag'
import {IDS} from "../../Constants/IDS";

export const GET_ORGANIZATIONS_BY_TYPE = gql`
    query ($parentOrgId:uuid!, $orgIds:[uuid!]){
        Organizations: Organizations(where: {parentOrgId: {_eq:$parentOrgId}, id: {_nin: $orgIds}}, order_by: {name: asc}){
            id
            name
            mobile
            zone
            lat
            long
            Type{
                id
                type
            }
        }
    }`

export const GET_ORGANIZATION_USER_BY_MOBILE = gql`
    query($userId:uuid!,$organizationId:uuid!,$mobile:String!){
        Organizations(where:{id:{_neq:$organizationId}, mobile:{_eq:$mobile}}){
            id
        },
        Users(where:{id:{_neq:$userId}, mobile:{_eq:$mobile}}){
            id
        }
    }`

export const GET_ORGANIZATION_BY_MOBILE = gql`
    query($mobile:String!){
        SuggetionOrganizations(where:{mobile:{_eq:$mobile}}){
            id
            name
            shopType
            gstInNumber
            status
            mobile
            whatsappNumber
            zone
            lat
            long
            totalDueAmount
            fssaiCode
            fssaiCodeExpiryDate
            Address{
                id
                address1
                address2
                area
                city
                state
                pincode
                country
            }
            Type{
                id
                type
            }
            Users(where:{userTypeId:{_eq:"121380be-fde4-4b3b-a6aa-98b543d529cf"}}){
                id
                name
                mobile
                email
                userTypeId
                birthDate
                anniversary
            }
        }
    }`

export const GET_ALL_CUSTOMERS_OF_DISTRIBUTOR = gql`
query getCustomersOfDistributor($orgId:uuid!){
    RouteShops(where: {Route: {organizationId: {_eq: $orgId}}}){
        id
        Route { id name }
        Organization { 
          id
          name
          mobile
          priceListId
          Users(where:{userTypeId:{_eq:"${IDS.userTypes.Customer}"}}){ id name mobile }
        }                
   }
}`